module.exports = __webpack_public_path__ + "img/bg_footer.39dc2a58.jpg";